// extracted by mini-css-extract-plugin
export var pillWrapper = "_nc-0";
export var showOverflow = "_nc-1";